import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";

import type { RootState } from "../../../store/store";
import { GameHeader } from "./index";

/**
 * Portal component that renders GameHeader into the NavBar.
 * Only renders when rosters are closed (game is active, not in setup).
 *
 * The NavBar handles visibility toggling purely via CSS:
 * - Portal container uses `empty:hidden` (hidden when no content)
 * - Title div uses `group-has-[...]:hidden` (hidden when portal has content)
 */
export function GameHeaderPortal() {
  const [container, setContainer] = useState<HTMLElement | null>(null);
  const areRostersOpen = useSelector(
    (state: RootState) => state.game.areRostersOpen,
  );

  useEffect(() => {
    const el = document.getElementById("game-header-container");
    setContainer(el);
  }, []);

  if (!container || areRostersOpen) return null;

  return ReactDOM.createPortal(<GameHeader />, container);
}
